import { cva } from '@/styled-system/css';

export const labeledControlRecipe = cva({
  base: {
    'display': 'flex',
    'gap': 'tighter',

    '& > .c11n_checkbox, & > .c11n_radio': {
      flexShrink: '0',
      marginBlockStart: 'tight',
    },

    '& > .c11n_switch__root': {
      flexShrink: '0',
      marginBlockStart: 'LabeledControl.padding.vert.switch.md',
    },

    '& > .c11n_label': {
      paddingBlock: 'LabeledControl.padding.vert.label',
      textStyle: 'body',
    },

    '& > .c11n_label:after': {
      content: 'none',
    },
  },
  variants: {
    fluid: {
      true: {
        justifyContent: 'space-between',
      },
      false: {},
    },
    labelPosition: {
      right: {},
      left: {
        '& > .c11n_label': {
          order: '-1',
        },
      },
    },
    size: {
      md: {},
      lg: {
        '& > .c11n_switch__root': {
          marginBlockStart: 'LabeledControl.padding.vert.switch.lg',
        },
      },
    },
  },
});
